import BasePolicy from '@/policies/BasePolicy.js';

export default class LocationPolicy extends BasePolicy {
    viewAny(user) {
        const permission = 'view all locations';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    view(user, location) {
        const permission = 'view a location';

        if (user.hasGroupPermissionTo(permission)) {
            return user.isInAssetGroup(location);
        }

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    create(user) {
        const permission = 'create a location';

        if (user.hasGroupPermissionTo(permission)) {
            return false;
        }

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    update(user, location) {
        const permission = 'edit a location';

        if (user.hasGroupPermissionTo(permission)) {
            return user.isInAssetGroup(location);
        }

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    delete(user) {
        const permission = 'delete a location';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }
}
